// extracted by mini-css-extract-plugin
export var label = "_ii-2";
export var slideContainer = "_ii-0";
export var slider = "_ii-1";